// LandingFooter

import Container from "../../../components/ui/Container";
import ulfaLogo from "../../../assets/logos/ulfa-logo.png";

export default function LandingFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="event-noise border-t border-white/10 bg-twilight-indigo-900 px-0 py-14 text-white md:py-16">
      <Container>
        <div className="mx-auto max-w-4xl text-center">
          {/* <div className="mx-auto mb-8 grid h-14 w-14 place-items-center rounded-full border border-white/20 bg-white text-sm font-bold text-twilight-indigo-950">
            UL
          </div> */}

          <div className="mx-auto mb-8 flex h-16 w-16 items-center justify-center overflow-hidden rounded-full border border-white/20 bg-white">
            <img
              src={ulfaLogo}
              alt="ULFA Logo"
              className="h-20 w-20 object-contain"
            />
          </div>

          <p className="text-xs font-bold uppercase tracking-[0.45em] text-white">
            ULFA
          </p>

          <p className="mt-3 text-xs font-semibold uppercase tracking-[0.35em] text-slate-400">
            University of Liberia Faculty Association
          </p>

          <div className="mx-auto my-10 h-px max-w-xl bg-white/10" />

          <div className="flex flex-col items-center justify-center gap-4 text-xs font-semibold uppercase tracking-[0.25em] text-slate-300 sm:flex-row sm:gap-8">
            <a href="#program" className="transition hover:text-amber-flame-500">
              Program
            </a>

            <a href="#officials" className="transition hover:text-amber-flame-500">
              Officials
            </a>

            <a href="#register" className="transition hover:text-amber-flame-500">
              Register
            </a>

            <a href="#downloads" className="transition hover:text-amber-flame-500">
              Downloads
            </a>
          </div>

          <p className="mx-auto mt-10 max-w-2xl font-serif text-xl italic leading-relaxed text-slate-200 md:text-2xl">
            Inauguration Ceremony &amp; Reconciliation Ball of the University of
            Liberia Faculty Association.
          </p>

          <div className="mt-10 grid gap-5 text-sm text-slate-400 md:grid-cols-3">
            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-amber-flame-500">
                Date
              </p>
              <p>Friday, May 8, 2026</p>
            </div>

            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-amber-flame-500">
                Ceremony
              </p>
              <p>9:00 AM – 12:00 PM</p>
            </div>

            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.3em] text-amber-flame-500">
                Ball
              </p>
              <p>5:00 PM – 9:00 PM</p>
            </div>
          </div>

          {/* <p className="mt-12 text-xs leading-6 text-slate-500">
            © {currentYear} University of Liberia Faculty Association. All
            rights reserved.
          </p> */}

          <div className="mt-12 space-y-2 text-xs leading-6 text-slate-500">
            <p>
              © {currentYear} University of Liberia Faculty Association. All rights
              reserved.
            </p>

            <p className="text-slate-700">
              Developed by{" "}
              <span className="font-semibold">
                Engr. Shaffa K. Kokro Jr., College of Engineering | UL
              </span>
            </p>
          </div>
        </div>
      </Container>
    </footer>
  );
}